// 赏金提现列表
export const withdrawalList = {
        'zh-CN': {
        partnerName: '伙伴合作名称',
        partnerNamePlaceholder: '请输入合作伙伴名称',
        phoneNumber: '手机号码',
        phoneNumberPlaceholder: '请输入手机号码',
        withdrawalTime: '提现时间',
        startDate: '开始日期',
        endDate: '结束日期',
        status: '状态',
        all: '全部',
        waitingPayment: '等待打款',
        paymentSuccess: '打款成功',
        rejected: '已驳回',
        approvedWaitingPayment: '审核通过待打款',
        paymentFailed: '打款失败',
        search: '搜索',
        partnerNameColumn: '伙伴合作名称',
        phoneColumn: '手机号',
        withdrawalAmount: '提现金额(港元)',
        applicationTime: '申请时间',
        statusColumn: '状态',
        paymentRejectTime: '打款/驳回时间',
        remark: '备注',
        operation: '操作',
        payment: '打款',
        reject: '驳回',
        rejectReason: '请输入驳回理由',
        rejectTitle: '驳回',
        confirm: '确定',
        cancel: '取消',
        rejectReasonRequired: '驳回理由不能为空',
        rejectSuccess: '驳回成功！',
        rejectFailed: '驳回失败！',
        cancelInput: '取消输入',
        paymentConfirmTitle: '打款',
        paymentConfirmMessage: '此操作不可逆，确认继续打款',
        operationSuccess: '操作成功！',
        operationFailed: '操作失败！',
        cancelled: '已取消'
      },
      'zh-TW': {
        partnerName: '夥伴合作名稱',
        partnerNamePlaceholder: '請輸入合作夥伴名稱',
        phoneNumber: '手機號碼',
        phoneNumberPlaceholder: '請輸入手機號碼',
        withdrawalTime: '提現時間',
        startDate: '開始日期',
        endDate: '結束日期',
        status: '狀態',
        all: '全部',
        waitingPayment: '等待打款',
        paymentSuccess: '打款成功',
        rejected: '已駁回',
        approvedWaitingPayment: '審核通過待打款',
        paymentFailed: '打款失敗',
        search: '搜索',
        partnerNameColumn: '夥伴合作名稱',
        phoneColumn: '手機號',
        withdrawalAmount: '提現金額(港元)',
        applicationTime: '申請時間',
        statusColumn: '狀態',
        paymentRejectTime: '打款/駁回時間',
        remark: '備註',
        operation: '操作',
        payment: '打款',
        reject: '駁回',
        rejectReason: '請輸入駁回理由',
        rejectTitle: '駁回',
        confirm: '確定',
        cancel: '取消',
        rejectReasonRequired: '駁回理由不能為空',
        rejectSuccess: '駁回成功！',
        rejectFailed: '駁回失敗！',
        cancelInput: '取消輸入',
        paymentConfirmTitle: '打款',
        paymentConfirmMessage: '此操作不可逆，確認繼續打款',
        operationSuccess: '操作成功！',
        operationFailed: '操作失敗！',
        cancelled: '已取消'
      },    
      'en': {
        partnerName: 'Partner Name',
        partnerNamePlaceholder: 'Please enter partner name',
        phoneNumber: 'Phone Number',
        phoneNumberPlaceholder: 'Please enter phone number',
        withdrawalTime: 'Withdrawal Time',
        startDate: 'Start Date',
        endDate: 'End Date',
        status: 'Status',
        all: 'All',
        waitingPayment: 'Waiting Payment',
        paymentSuccess: 'Payment Success',
        rejected: 'Rejected',
        approvedWaitingPayment: 'Approved Waiting Payment',
        paymentFailed: 'Payment Failed',
        search: 'Search',
        partnerNameColumn: 'Partner Name',
        phoneColumn: 'Phone',
        withdrawalAmount: 'Withdrawal Amount (Yuan)',
        applicationTime: 'Application Time',
        statusColumn: 'Status',
        paymentRejectTime: 'Payment/Reject Time',
        remark: 'Remark',
        operation: 'Operation',
        payment: 'Payment',
        reject: 'Reject',
        rejectReason: 'Please enter reject reason',
        rejectTitle: 'Reject',
        confirm: 'Confirm',
        cancel: 'Cancel',
        rejectReasonRequired: 'Reject reason cannot be empty',
        rejectSuccess: 'Reject successful!',
        rejectFailed: 'Reject failed!',
        cancelInput: 'Cancel input',
        paymentConfirmTitle: 'Payment',
        paymentConfirmMessage: 'This operation is irreversible, confirm to continue payment',
        operationSuccess: 'Operation successful!',
        operationFailed: 'Operation failed!',
        cancelled: 'Cancelled'
      }
    }